import { render, staticRenderFns } from "./ManualEdit.vue?vue&type=template&id=15bf4429&scoped=true"
import script from "./ManualEdit.vue?vue&type=script&lang=js"
export * from "./ManualEdit.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "15bf4429",
  null
  
)

export default component.exports